import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeGridConfig, ScreenClassProvider } from 'shared-portal-component';

import 'shared-portal-component/dist/shared-portal-component.css'

import App from "@/App";
import '@/styles/index.css';
import '@/styles/ResetCss.scss';


initializeGridConfig();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- root element guaranteed to exist in index.html
createRoot(document.getElementById('root')!).render(
  <StrictMode>
     <ScreenClassProvider>
    <App />
    </ScreenClassProvider>
  </StrictMode>
);
